module.exports = __webpack_public_path__ + "img/logo-ultima.fa6a55d3.png";